import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
    createStyles({
        rtwFieldsBox: {
            border: '1px solid #D6DDE2',
            borderRadius: 4,
            backgroundColor: '#FFFFFF',
            padding: theme.spacing(2),
            marginBottom: theme.spacing(2.5),
        },
        rtwField: {
            marginBottom: theme.spacing(2),
        },
        rtwSelect: {
            backgroundColor: '#FFFFFF',
            width: '100%',
        },
    }),
);
